import React, { useEffect, useState } from "react";
import "./PatientBookContainer.scss";
import { connect } from "react-redux";
import { bedDetailConfigAction, modalAction } from "../../modules/actions/action";
import { ADD, DEVICE_TYPES, REMOVE, BED_DETAILS_MODULE } from "../../common/constant/common-constants";
import { PAGE_CONST } from "../../common/constant/page-constants";
import { redirect } from "../../common/utils/RedirectionUtils";
import { useNavigate } from "react-router-dom";

function PatientBookContainer(props) {
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(""); // update with bed-number
    const [bedIdArray, setBedIdArray] = useState(props.bedIdArray);

    useEffect(() => {
        setBedIdArray(props.bedIdArray);
    }, [props.bedIdArray])

    const handleIsOpenClick = (bedId) => {

        if (isOpen === bedId) setIsOpen("");
        else setIsOpen(bedId);
    }


    const handleActionClick = (bedId, item) => {

        console.log("this action was clicked", item);
        let data = {
            bedId: bedId
        }
        redirect(navigate, PAGE_CONST.BED_DETAILS, data);
    }

    return (
        <div className="bed-list-container">
            <table className="bed-list-table">
                <thead>
                    <tr className="bed-list-header-row">
                        <th className="bed-list-header bed">
                            BED
                        </th>
                        <th className="bed-list-header">
                            PATIENT
                        </th>
                        <th className="bed-list-header">
                            PATIENT ID
                        </th>
                        <th className="bed-list-header">
                            GENDER
                        </th>
                        <th className="bed-list-header">
                            ADMISSION DATE
                        </th>
                        <th className="bed-list-header">
                            ADMISSION TIME
                        </th>
                        <th className="bed-list-header">
                            DISCHARGE DATE
                        </th>
                        <th className="bed-list-header">
                            DISCHARGE TIME
                        </th>
                        <th className="bed-list-header">
                            DAYS ADMITTED
                        </th>
                        {/* <th className="bed-list-header">
                            AGE
                        </th>
                        <th className="bed-list-header">
                            HEIGHT (cm)
                        </th>
                        <th className="bed-list-header">
                            WEIGHT (kg)
                        </th> */}
                        <th className="bed-list-header">
                            ACTIONS
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {bedIdArray.map((bedId) => {

                        let patientData = props.patientData[bedId];
                        if (props.wardData && props.wardData.bedList && (props.wardData.bedList.indexOf(bedId) <= -1)) return;
                        let ref = React.createRef();
                        let bedName = props.bedDetails && props.bedDetails[bedId] && props.bedDetails[bedId].bedName;
                        return (<tr key={bedId} ref={ref}>
                            <td className="bed-list-body">
                                <div className="bed-number">{bedName}</div>
                            </td>

                            <td className="bed-list-body">
                                <div className="">
                                    {patientData.name || "-"}
                                </div>
                            </td>
                            <td className="bed-list-body">
                                <div className="uhid">
                                    {patientData.uhid || '-'}
                                </div>
                            </td>
                            <td className="bed-list-body">
                                <div className="">
                                    {patientData.gender || "-"}
                                </div>
                            </td>
                            <td className="bed-list-body">
                                <div className="admissionDate">
                                    {patientData.admissionDate || '-'}
                                </div>
                            </td>
                            <td className="bed-list-body">
                                <div className="admissionTime">
                                    {patientData.admissionTime || '-'}
                                </div>
                            </td>
                            <td className="bed-list-body">
                                <div className="dischargeDate">
                                    {patientData.dischargeDate || '-'}
                                </div>
                            </td>
                            <td className="bed-list-body">
                                <div className="dischargeTime">
                                    {patientData.dischargeTime || '-'}
                                </div>
                            </td>
                            <td className="bed-list-body">
                                <div className="daysAdmitted">
                                    {patientData.daysAdmitted || '-'}
                                </div>
                            </td>
                            {/* <td className="bed-list-body">
                                <div className="">
                                    {patientData.age || "-"}
                                </div>
                            </td>
                            <td className="bed-list-body">
                                <div className="">
                                    {patientData.height || "-"}
                                </div>
                            </td>
                            <td className="bed-list-body">
                                <div className="">
                                    {patientData.weight || "-"}
                                </div>
                            </td> */}

                            <td className="bed-list-body">
                                <div className="action-container" onClick={() => handleIsOpenClick(bedId)} >
                                    <span className="documentation"
                                        onClick={() => handleActionClick(bedId, BED_DETAILS_MODULE.PATIENT_DETAILS)}>
                                        View
                                    </span>
                                </div>
                            </td>
                        </tr>);
                    })}
                </tbody>
            </table >
        </div >
    )
}

const mapStateToProps = (state, ownProps) => {

    return {
        bedIdArray: state.bedDetailsReducer.bedIdArray,
        bedDetails: state.bedDetailsReducer.bedDetails,
        patientData: state.patientDataReducer.patientData,
        listViewParameters: (state.configReducer.config && state.configReducer.config.listViewParameters)
    }
}

const mapDispatchToProps = (dispatch) => {

    return {
        bedDetailConfigAction: (payload) => dispatch(bedDetailConfigAction(payload)),
        modalAction: (payload) => dispatch(modalAction(payload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientBookContainer);

